import {
  Clock,
  DollarSign,
  Edit,
  Eye,
  Filter,
  MapPin,
  MoreVertical,
  Package,
  Plus,
  Search,
  Trash2,
  Truck,
  Users,
} from "lucide-react";
import React, { useState } from "react";

import { useAppSelector } from "@/hooks/redux";

import CourierManagement from "./management/CourierManagement";
import FleetManagement from "./management/FleetManagement";
import RestaurantManagement from "./management/RestaurantManagement";

// Courier Management
interface Courier {
  completedDeliveries: number;
  email: string;
  id: string;
  name: string;
  phone: string;
  rating: number;
  status: "active" | "offline" | "on-delivery";
  zone: string;
}

// Restaurant Menu Management
interface MenuItem {
  category: string;
  description: string;
  id: string;
  image?: string;
  isAvailable: boolean;
  name: string;
  price: number;
}

// Fleet Vehicle Management
interface Vehicle {
  driverId?: string;
  id: string;
  licensePlate: string;
  make: string;
  mileage: number;
  model: string;
  status: "active" | "inactive" | "maintenance";
  year: number;
}

const Management: React.FC = () => {
  const [activeTab, setActiveTab] = useState("");

  // Tabs for each business type
  const getTabsForBusinessType = () => {
    if (user?.role === "RestaurantOwner") {
      return [
        { icon: Package, id: "items", label: "Menu Items" },
        { icon: Filter, id: "categories", label: "Categories" },
        { icon: Clock, id: "orders", label: "Orders" },
      ];
    }
    if (user?.role === "FleetOwner") {
      return [
        { icon: Truck, id: "vehicles", label: "Vehicles" },
        { icon: Users, id: "drivers", label: "Drivers" },
        { icon: Package, id: "maintenance", label: "Maintenance" },
      ];
    }
    // CourierOwner
    return [
      { icon: Users, id: "couriers", label: "Couriers" },
      { icon: MapPin, id: "zones", label: "Service Zones" },
      { icon: Package, id: "deliveries", label: "Deliveries" },
    ];
  };
  const { user } = useAppSelector((state) => state.auth);
  const renderContent = () => {
    if (user?.role === "RestaurantOwner") {
      return <RestaurantManagement />;
    }
    if (user?.role === "FleetOwner") {
      return <FleetManagement />;
    }
    return <CourierManagement />;
  };

  return (
    <div className="min-h-screen p-4 dark:bg-gray-900 sm:p-6">
      <div className="mb-4 sm:mb-6">
        <h1 className="mb-2 text-2xl font-bold text-gray-900 dark:text-gray-100 sm:text-3xl">
          Management
        </h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 sm:text-base">
          Manage your business operations and resources.
        </p>
      </div>

      {/* Content */}
      <div className="rounded-lg bg-gray-50 p-4 dark:bg-gray-800/50 sm:p-6">
        {renderContent()}
      </div>
    </div>
  );
};

export default Management;
